import {
  Box,
  Text,
  HStack,
  Heading,
  Select,
  Stack,
  Image,
  SimpleGrid,
  Flex,
} from "@chakra-ui/react";
import React from "react";

export default function AnalyticsOverview() {
  return (
    <Stack gap={2} height="full">
      <HStack justifyContent={"space-between"}>
        <Heading
          fontSize={{ base: "18px", md: "24px" }}
          fontWeight={"semibold"}
        >
          Overview
        </Heading>
        <Select
          w="fit-content"
          border="0px"
          display={{ base: "block", md: "none" }}
        >
          <option>Last 30 Days</option>
          <option>Last 14 Days</option>
          <option>Last 7 Days</option>
        </Select>
      </HStack>
      <Box p={5} border="1px solid #c5c5c5" height="full">
        <HStack justifyContent={"space-between"}>
          <Select
            w="fit-content"
            border="0px"
            display={{ base: "none", md: "block" }}
          >
            <option>Last 30 Days</option>
            <option>Last 14 Days</option>
            <option>Last 7 Days</option>
          </Select>

          <SimpleGrid
            gap={1}
            columns={{ base: 2, lg: 4 }}
            alignItems={"center"}
            fontSize={{ base: "11px", "2xl": "15px" }}
            flexWrap="wrap"
            w="fit-content"
          >
            <CommonStatFlexBox title="Sale PKR 0" color="#E4F3FB" />
            <CommonStatFlexBox title="Cancelled PKR 0" color="#C5C5C5" />
            <CommonStatFlexBox title="Completed 0" color="#1AFF00" />
            <CommonStatFlexBox title="New Orders 0" color="#DD00FF" />
          </SimpleGrid>
        </HStack>
        <Stack
          alignItems="center"
          justifyContent={{ base: "space-between", md: "center" }}
          flexDir={{ base: "row", md: "column" }}
          py={{ base: 5, md: 0 }}
        >
          <PKRChartLineColumn />
          <Flex justifyContent="center" w="80%">
          <Stack
            alignItems="center"
            justifyContent="center"
            gap={2}
            p={{ base: 2, md: 8 }}
            border="1px solid #c5c5c5"
            
            borderRadius={10}
            height="full"
            m={{ base: 5, md: 20 }}
          >
            <Image src="/images/freelancer/analytics/no-order.png" maxW={{ base: "180px", lg: "300px" }}/>
            <Heading
              fontSize={{ base: "13px", md: "17px" }}
              fontWeight="semibold"
              align="center"maxW={{ base: "180px", lg: "300px" }}
            >
              No Order To Display
            </Heading>
            <Text fontSize={"14px"}maxW={{ base: "180px", lg: "300px" }} align="center" color="#c5c5c5">
              There is no data available within the selected timeframe.
            </Text>
          </Stack>
          </Flex>
          <PKRChartLineRow />
        </Stack>
      </Box>
    </Stack>
  );
}
const CommonStatFlexBox = ({ title, color }) => {
  return (
    <HStack gap={1}>
      <Box
        as="span"
        p={2}
        bg={color}
        borderRadius={"full"}
        display="inline-block"
      />
      <Text>{title}</Text>
    </HStack>
  );
};

const PKRChartLineRow = () => {
  return (
    <Flex
      borderTop="1px solid #c5c5c5"
      justifyContent="space-between"
      w="full"
      display={{ base: "none", md: "flex" }}
    >
      <Stack spacing={0}>
        <Box w="1px" bg="#c5c5c5" height="15px" />
        <Text>PKR 0</Text>
      </Stack>
      <Stack spacing={0}>
        <Box w="1px" bg="#c5c5c5" height="15px" />
        <Text>PKR 1</Text>
      </Stack>
      <Stack spacing={0}>
        <Box w="1px" bg="#c5c5c5" height="15px" />
        <Text>PKR 2</Text>
      </Stack>
      <Stack spacing={0}>
        <Box w="1px" bg="#c5c5c5" height="15px" />
        <Text>PKR 3</Text>
      </Stack>
      <Stack spacing={0} align="end">
        <Box w="1px" bg="#c5c5c5" height="15px" />
        <Text>PKR 4</Text>
      </Stack>
    </Flex>
  );
};
const PKRChartLineColumn = () => {
  return (
    <Stack
      borderRight="1px"
      borderColor="#c5c5c5"
      fontSize="12px"
      mx="10px"
      height="250px"
      justifyContent="space-between"
      display={{base:"flex",md:"none"}}
    >
      <Flex alignItems={"start"}>
        <Text>PKR 0</Text>
        <Box w="10px" height="1px" bg="#c5c5c5" />
      </Flex>
      <Flex alignItems={"center"}>
        <Text>PKR 1</Text>
        <Box w="10px" height="1px" bg="#c5c5c5" />
      </Flex>
      <Flex alignItems={"center"}>
        <Text>PKR 2</Text>
        <Box w="10px" height="1px" bg="#c5c5c5" />
      </Flex>
      <Flex alignItems={"center"}>
        <Text>PKR 3</Text>
        <Box w="10px" height="1px" bg="#c5c5c5" />
      </Flex>
      <Flex alignItems={"end"}>
        <Text>PKR 4</Text>
        <Box w="10px" height="1px" bg="#c5c5c5" />
      </Flex>
    </Stack>
  );
};
